import type { TLiveVoiceOption } from "@/types/TLiveAvatarOption";
import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface VoicesApiResponse {
  code: number;
  data: {
    count: number;
    results: TLiveVoiceOption[];
  };
}

export async function fetchAvailableVoices(): Promise<TLiveVoiceOption[]> {
  try {
    const response = await authenticatedFetchJson<VoicesApiResponse>("/api/heygen/voices");
    return response?.data?.results ?? [];
  } catch (error) {
    console.error("[fetchAvailableVoices] Error:", error);
    throw error;
  }
}
